module.exports = "https://99designs-start-assets.imgix.net/js/145aed236621cd98b74a3e9141ded633.svg";